module.exports = __webpack_public_path__ + "static/media/SR.14120043.svg";